import { useState, FunctionComponent } from 'react'

import cx from 'classnames'
import InfoOutlined from '@material-ui/icons/InfoOutlined'
import withStyles from '@material-ui/core/styles/withStyles'
import MuiPopover from '@material-ui/core/Popover'

import TileInfoPopoverContentContainer from 'redux/containers/components/tiled-menu/TileInfoPopoverContentContainer'

const Popover = withStyles({
  paper: {
    borderRadius: 0
  }
})(MuiPopover)

const TileInfoPopover:FunctionComponent<TileInfoPopoverProps> = ({ title, getUrl, nodes, sectionId, cxNames, contentOverride }) => {
  const { iconColor } = cxNames.tile
  const [anchorEl, setAnchorEl] = useState(null)

  return (
    <div>
      <span
        className={cx('absolute bottom4 left5', iconColor)}
        onMouseEnter={(e: any) => {
          e.preventDefault()
          setAnchorEl(e.currentTarget)
        }}
        data-testid="tile-info-icon"
      >
        <InfoOutlined className='vm' />
      </span>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'center', horizontal: 'left' }}
        transformOrigin={{ vertical: 'center', horizontal: 'center' }}
        transitionDuration={{ enter: 300, exit: 300 }}
      >
        <div onMouseLeave={() => setAnchorEl(null)}>
          <TileInfoPopoverContentContainer
            {...{ title, getUrl, sectionId, nodes, cxNames, contentOverride }}
            remove={() => setAnchorEl(null)}
          />
        </div>
      </Popover>
    </div>
  )
}

interface TileInfoPopoverProps {
  title: string;
  getUrl: (...args:any) => string;
  nodes:any;
  sectionId:string;
  cxNames:any;
  contentOverride:any;
}

export default TileInfoPopover
